import { httpClient } from '@/core/api/client/httpClient'
import { round2 } from '@/shared/utils/formatters'

export interface ProductoGrupo {
  id: number
  codigo: string
  nombre: string
  descripcion: string | null
  tasaAnualMinima: number
  tasaAnualMaxima: number
  diasMinPermanencia: number
}

interface BffProductosResponse {
  success: boolean
  data: { grupos: ProductoGrupo[] }
}

export const productosService = {
  async listar(lang?: string): Promise<ProductoGrupo[]> {
    const normalizedLang = lang?.trim().toLowerCase() === 'en' ? 'en' : 'es'
    const res = await httpClient.get<BffProductosResponse>(`/api/productos?lang=${normalizedLang}`)
    return (res.data?.grupos ?? []).map((grupo) => ({
      ...grupo,
      tasaAnualMinima: round2(grupo.tasaAnualMinima) ?? 0,
      tasaAnualMaxima: round2(grupo.tasaAnualMaxima) ?? 0,
    }))
  },
}
